export const FETCH_ACCOUNT = 'FETCH_ACCOUNT'
export const FETCH_ACCOUNT_SUCCESS = 'FETCH_ACCOUNT_SUCCESS'
export const FETCH_ACCOUNT_FAILURE = 'FETCH_ACCOUNT_FAILURE'

export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS'
export const UPDATE_ACCOUNT_FAILURE = 'UPDATE_ACCOUNT_FAILURE'

export const UPDATE_NEWSTATUS = 'UPDATE_NEWSTATUS'
export const UPDATE_NEWSTATUS_SUCCESS = 'UPDATE_NEWSTATUS_SUCCESS'
export const UPDATE_NEWSTATUS_FAILURE = 'UPDATE_NEWSTATUS_FAILURE'

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE'


export const fetchAccount = () => ({
    type: FETCH_ACCOUNT
})

export const fetchAccountSuccess = (account) => ({
    type: FETCH_ACCOUNT_SUCCESS,
    payload: account
})

export const fetchAccountFailed = (message) => ({
    type: FETCH_ACCOUNT_FAILURE,
    payload: message
})


export const updateAccount = (account) => ({
    type: UPDATE_ACCOUNT,
    payload: account
})

export const updateAccountSuccess = (message) => ({
    type: UPDATE_ACCOUNT_SUCCESS,
    payload: message
})

export const updateAccountFailed = (message) => ({
    type: UPDATE_ACCOUNT_FAILURE,
    payload: message
})


export const updateNewStatus = (account) => ({
    type: UPDATE_NEWSTATUS,
    payload: account
})

export const updateNewStatusSuccess = (message) => ({
    type: UPDATE_NEWSTATUS_SUCCESS,
    payload: message
})

export const updateNewStatusFailed = (message) => ({
    type: UPDATE_NEWSTATUS_FAILURE,
    payload: message
})


export const updatePassword = (password) => ({
    type: UPDATE_PASSWORD,
    payload: password
})

export const updatePasswordSuccess = (message) => ({
    type: UPDATE_PASSWORD_SUCCESS,
    payload: message
})

export const updatePasswordFailed = (message) => ({
    type: UPDATE_PASSWORD_FAILURE,
    payload: message
})